import { Box, HStack, Header, Pressable } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const ProductCustomizationPanel = Box.withConfig({
  height: 'full',
  width: 'full',
  alignSelf: 'center',
});

export const GroupsCustomizationModifiersContainer = Box.withConfig({
  width: 'full',
  margin: 0,
  padding: 0,
});

export const ModifiersCustomizationContainer = Box.withConfig({
  width: 'full',
  paddingX: '$2',
  paddingY: '$4',
  backgroundColor: primitive.$blackOpacity4,
  marginY: '$4',
  borderRadius: Styles.borderRadius,
});

export const DrinksTabLink = Pressable.withConfig<{ active: boolean }>(({ active }) => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  fontFamily: Styles.fontFamily.body,
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: active ? 2 : 0,
  borderBottomColor: active ? Styles.color.tertiary : 'transparent',
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: active ? Styles.color.tertiary : 'transparent',
      md: active ? Styles.color.black : 'transparent',
    },
  },

  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const DrinksTabLinkText = Header.withConfig<{ active?: boolean }>(({ active }) => ({
  color: active ? Styles.color.tertiary : Styles.color.tertiary,
  fontFamily: active ? Styles.fontFamily.base : Styles.fontFamily.body,
  marginTop: 0,
  fontSize: { md: 'sm' },
  lineHeight: { md: 'md' },
}));

export const DrinksTabsWrapper = HStack.withConfig({
  position: 'relative',
  width: 'full',
  height: Styles.layout.navHeight.mobile,
  background: 'transparent',
  marginY: '$0.5',
  paddingTop: '$2',
  paddingX: 0,
});

export const DrinksTabsContent = Box.withConfig({
  marginTop: { base: '$6', md: '$8' },
});
